
import "./axiosInterceptor";
import apiWebhook from "./apiWebhook";

const getWebhook = async (params) => {
  const endpoint = "/webhook/pagos-notificados";
  const { data } = await apiWebhook.get(endpoint, {params});

  return data;
};

export default { getWebhook };